import { render } from "./DynamicDownloadCenter.vue?vue&type=template&id=dd773552&scoped=true"
import script from "./DynamicDownloadCenter.vue?vue&type=script&lang=js"
export * from "./DynamicDownloadCenter.vue?vue&type=script&lang=js"

import "./DynamicDownloadCenter.vue?vue&type=style&index=0&id=dd773552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd773552"]])

export default __exports__